import Azure from "../assets/png/Azure.png";
import C_For_Everyone from "../assets/png/C_For_Everyone.png";
import Web_Development_Bootcamp from "../assets/png/Web_Development_Bootcamp.png";
export const certificateData = [
	{
		id: 1,
		image: Azure,
		title: "Microsoft Azure AI Fundamentals",
		link: "https://drive.google.com/file/d/150-katGa2d_uRuqTNwBI-erZoi16-wvE/view?usp=sharing",
	},
	{
		id: 2,
		image: C_For_Everyone,
		title: "C For Everyone",
		link: "https://drive.google.com/file/d/196tGDGsOkRe17G3CvsIihDemc8wJsxs9/view?usp=sharing",
	},
	{
		id: 3,
		image: Web_Development_Bootcamp,
		title: "Complete Web Development Bootcamp",
		link: "https://drive.google.com/file/d/1r9837sZjaKxZX8ZWfcqN0_KzaW_RPjlK/view?usp=sharing",
	},
];
